import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-careers',
  templateUrl: './new-careers.component.html',
  styleUrls: ['./new-careers.component.scss']
})
export class NewCareersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  scrollToOpenRoles(): void {
    document.getElementById('open-roles')?.scrollIntoView({ behavior: 'smooth' });
  }

}
